import { faSearch, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import {
  getSearchPractitionerList,
  invitePractitioner,
} from "../../actions/practitionerAction";
import { setActivePractitionerForProfile } from "../../actions/roleAction";
import Avatar from "../../assets/images/default-avatar.jpg";
import history from "../../utils/history";
import Loader from "../../components/Loader";
const AddNewPractitionerPopup = ({ closePopup }) => {
  const dispatch = useDispatch();
  const [filteredList, setFilteredList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const searchPractitionerList = useSelector(
    (state) => state.practitioner.searchPractitionerList
  );
  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getSearchPractitionerList(() => {
        setIsLoading(false);
      })
    );
  }, [dispatch]);

  useEffect(() => {
    setFilteredList(searchPractitionerList);
  }, [searchPractitionerList]);

  const handleChange = (e) => {
    let searchTerm = e.target.value;

    let newList = searchPractitionerList.filter((x) => {
      const fullName = `${x.first_name} ${x.last_name}`.toLowerCase();
      const search = searchTerm.toLowerCase();

      return (
        fullName.includes(search) ||
        x.first_name.toLowerCase().includes(search) ||
        x.last_name.toLowerCase().includes(search) ||
        x.clinic_name?.toLowerCase().includes(search) ||
        x.clinic_url?.toLowerCase().includes(search)
      );
    });
    setFilteredList(newList);
  };
  const profileAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <button
        className="profile-icon"
        onClick={() => {
          history.push("/app/practitioner/info");
          dispatch(setActivePractitionerForProfile(row.practitioner_id));
        }}
      >
        <img src={Avatar} alt="icon" /> <span>View</span>
      </button>
    );
  };
  const requestAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div className="action-btn-wrapper row">
          <button
            className=" btn-orange  btn-table "
            onClick={() => {
              dispatch(
                invitePractitioner(row.practitioner_id, () => {
                  dispatch(getSearchPractitionerList());
                })
              );
            }}
          >
            Request
          </button>
        </div>
      </>
    );
  };
  const columns = [
    {
      dataField: "practitioner_id",
      text: "Profile",
      sort: false,
      headerStyle: {
        width: "100px",
      },
      formatter: profileAction,
    },
    {
      dataField: "first_name",
      text: "Name",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            {" "}
            <p>
              {row.first_name} {row.last_name}
            </p>
          </>
        );
      },
    },

    {
      dataField: "clinic_name",
      text: "Clinic",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <p>{row.clinic_name}</p>
            <p
              style={{ color: "#f79225", cursor: "pointer" }}
              target="_blank"
              onClick={() =>
                window.open(
                  `http://${row.clinic_url.replace(/(^\w+:|^)\/\//, "")}`,
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              {row.clinic_url}
            </p>
          </>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: requestAction,
    },
  ];
  return (
    <Modal size="xl" show={true} id="prescription-popup">
      <Modal.Body>
        {searchPractitionerList.length > 0 ? (
          <>
            <div className="prescription-detail">
              <div className="close-btn">
                <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
              </div>
              <div className="inner-section">
                <div className="row">
                  <div className="col-md-12">
                    <h2 className="heading">Add New Practitioner</h2>
                  </div>
                </div>
                <div className="row mb-1">
                  <div className="col-md-6">
                    <div className="form-group search">
                      <div>
                        <label htmlFor="search">
                          {" "}
                          Search: (Practitioner name, clinic or website)
                        </label>
                        <div className="input">
                          <input
                            name="search"
                            className="form-control"
                            id="search"
                            onChange={handleChange}
                            type="text"
                          ></input>
                        </div>
                      </div>
                      <FontAwesomeIcon icon={faSearch} size="lg" color="gray" />
                    </div>
                  </div>
                </div>
                <div style={{ backgroundColor: "white" }}>
                  <BootstrapTable
                    style={{ backgroundColor: "white" }}
                    classes="react-bootstrap-table"
                    keyField="uniqueId"
                    columns={columns}
                    data={filteredList}
                    headerClasses="header-class"
                  />
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
            </div>
            <div className="inner-section">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="heading">Add New Practitioner</h2>
                </div>
              </div>
              <div style={{ backgroundColor: "white", padding: "20px 0" }}>
                <p className="page-desc">
                  There are no practitioner at this time
                </p>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
export default AddNewPractitionerPopup;
